<template>

  <MembershipBannerBar v-if="!userStore.isFullMember()">
    Full members see search results for <i>all</i> ceremonies.
  </MembershipBannerBar>

  <div class="container mol-typical-page-container-20" :class="{'showing-message-banner': !userStore.isFullMember()}">
    <div class="results-header" v-if="resultsHeader.length > 0">
      <div class="results-header-title" v-html="resultsHeader"></div>
      <div class="results-header-subtitle" v-if="!userStore.isFullMember()">
        <span class="asterisk">*</span>found among this year's nominated films<br>
        <router-link to="/membership">Subscribe</router-link> to search <span style="font-weight: 500">all</span> the years.
      </div>
    </div>

    <LoadingSpinner v-if="isSearching" class="text-secondary" loading_text="searching" style="margin-top: 50px;"></LoadingSpinner>

    <div v-else>
      <FilmChecklist :films="filmlist" :show_years="true" />

<!--
      <MembershipPitchCard v-if="!userStore.isFullMember()" class="membership-card">
        Interested in seeing results for <i>every</i> ceremony?
      </MembershipPitchCard>
-->
    </div>
  </div>
</template>


<script>
import axios from "axios";
import FilmChecklist from "@/components/FilmChecklist.vue";
import {FilmTitleInfo} from "@/film";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import analytics from "@/analytics";
import {userStore} from "@/userStore";
import MembershipPitchCard from "@/components/purchases/MembershipPitchCard.vue";
import MembershipBannerBar from "@/components/MembershipBannerBar.vue";

export default {
  name: "SearchResultsPage",
  // eslint-disable-next-line
  components: {MembershipBannerBar, MembershipPitchCard, LoadingSpinner, FilmChecklist},
  data() {
    return {
      isSearching: true,
      resultsHeader: "",
      filmlist: []
    }
  },

  created() {

    this.$watch(
        () => this.$route.query,
        (/*newText, oldText*/) => {
          this.doSearch();
        }
    );

    this.doSearch();

    // EventBus.on('search-term-updated', (_type, _text) => {
    //   // console.log(`search-term-updated ( "${_type}", "${_text}" )`);
    //   this.doSearch();
    // });
  },

  computed: {
    userStore() {
      return userStore;
    },
  },

  methods: {
    async doSearch() {

      this.filmlist = [];

      const searchType = this.$route.query.searchType;
      const searchText = this.$route.query.searchText;

      if ( !searchType || searchType === '' || !searchText || searchText === '') {
        this.resultsHeader = `no results`;
        this.isSearching = false;
        return;
      }

      this.resultsHeader = `Searching for ${searchType} containing "${searchText}"`;
      this.isSearching = true;

      axios.get(`/api/film/search/${searchType.toLowerCase()}/${encodeURIComponent(searchText)}`, {
        params: {
          wholeWordMatch: (searchText.length < 3), // force whole-word searches for one or two character strings
          maxResults: 500
        }
      })
          .then((response) => {
            this.filmlist = response.data.map(f => new FilmTitleInfo(f));

            const formattedFilm = (this.filmlist?.length !== 1) ? 'films' : 'film';
            const formattedSearchType = (
                (this.filmlist?.length !== 1)? searchType.toLowerCase() : // trivial case: not exactly one film is just the lower-case search type
                    (searchType === 'Overviews')? 'an overview' :         //  one overview is "an overview"
                        'a ' + searchType.toLowerCase().slice(0,-1)       //  one film or nominee is "a film" or "a nominee"
            );
            this.resultsHeader = `<b>${this.filmlist.length}</b> ${formattedFilm} with ${formattedSearchType} containing <i>"${searchText}"</i>`;

            // console.log(this.resultsHeader)
            //Film.sortFilmsByPrioirity(this.filmlist);
          })
          .catch((err) => {
            analytics.notifyBugsnagOfError(err);
          })
          .finally(() => {
            this.isSearching = false;
          })
    }
  }

}
</script>


<style scoped>

.results-header {
  padding-bottom:2.25em;
  width: fit-content;

  .results-header-title {
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.0;
  }

  .results-header-subtitle {
    font-size: small;
    color: var(--bs-secondary-color);
    font-style: italic;
    text-align: right;
    margin: 0.375em 1em 0 0;

    .asterisk {
      /*color: var(--mol-color-red-carpet);*/
      margin-right: 0.1em;
    }

    a {
      text-decoration: inherit;
      color: inherit;
      /*font-weight: 500;*/
    }
  }
}

.membership-card {
  margin-top: 2em;
}

</style>